import React from "react";
import "./DeepCleaningService.css";

const DeepCleaningService = () => {
  return (
    <div className="deep-cleaning-container">
      <h1>Your Home Deserves a Deeper Clean</h1>
      <p>
        Our Deep Cleaning service is the perfect choice for those times when a
        regular cleaning just is not enough.
      </p>
      <p>
        Whether you're preparing for guests, recovering from a busy season, or
        simply wanting to refresh your home from top to bottom, our detailed
        approach ensures every corner is addressed. We go far beyond surface
        cleaning, eliminating hidden dirt, grime, allergens, and buildup in areas
        often overlooked. This service not only revitalizes your living space but
        also promotes a healthier home environment for you and your loved ones.
      </p>
      <p>
        We recommend deep cleaning for first-time cleanings, seasonal refreshes,
        or homes that haven’t been professionally cleaned in a while. Our expert
        team uses high-quality equipment and eco-friendly products to deliver
        exceptional results every time.
      </p>

      <h2>What’s Included in Our Deep Cleaning Service?</h2>
      <p>
        We customize each visit to fit your home's unique needs, but a typical
        Deep Cleaning service may include:
      </p>
      <ul>
        <li>✔ Cleaning behind and underneath furniture</li>
        <li>✔ Inside and outside of kitchen cabinets</li>
        <li>✔ Detailed scrubbing of bathroom tiles and fixtures</li>
        <li>✔ Dusting ceiling fans, vents, blinds, and baseboards</li>
        <li>✔ Cleaning interior windows and windowsills</li>
        <li>✔ Sanitizing high-touch surfaces (doorknobs, switches, etc.)</li>
        <li>✔ Washing walls and doors (if needed)</li>
        <li>✔ Vacuuming and mopping under beds and large furniture</li>
        <li>✔ Thorough kitchen appliance cleaning (microwave, oven exterior, fridge exterior)</li>
        <li>✔ Trash removal and bin sanitization</li>
      </ul>

      <h2>Why Choose Us for Deep Cleaning?</h2>
      <ul>
        <li><strong>Meticulous Attention to Detail</strong> – We don’t just clean, we care. Our team takes the time to reach those often-overlooked areas to ensure your space feels truly refreshed.</li>
        <li>🧼 <strong>Safe for Your Family & the Environment</strong> – We exclusively use eco-friendly, non-toxic, and pet-safe products to protect the health of your loved ones and the planet.</li>
        <li>🕒 <strong>Convenient, Flexible Scheduling</strong> – Life is busy, we get it. That’s why we offer flexible appointments that work around your schedule, not the other way around.</li>
        <li>💬 <strong>Clear and Friendly Communication</strong> – From start to finish, we keep you informed with a warm, transparent approach. You will always know what to expect, with no surprises.</li>
        <li>🤝 <strong>Your Satisfaction, Our Priority</strong> – We take pride in our work and stand by it. If you’re not completely satisfied, we’ll make it right because your trust means everything to us.</li>
      </ul>
    </div>
  );
};

export default DeepCleaningService;
